import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class CarouselItem extends React.PureComponent {
    static propTypes = {
        title: PropTypes.bool,
        number: PropTypes.string
    };
    render() {
        const {title, number} = this.props;
        const imageClasses = classNames('image', {small: title});
        return (
            <div className="carousel-item">
                <div className={imageClasses}>
                    <h3>{number}</h3>
                </div>
                {title ? (
                    <h2>Title of element would go here</h2>
                ) : null}
            </div>
        );
    }
}

